import { Trans, useTranslation } from 'react-i18next';
import classes from './Tabs.module.scss';
import { useState } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css";
import 'swiper/css/grid';
import arrow from '../../../assets/img/Home/WhyChoose/arrow.png';
import check from '../../../assets/img/Home/UnderBanner/check.png';
import Button from '../../GlobalComponents/Button/Button';

const cards = [
    {
        route: 'services/plumbing',
        title: 'services.tabs.plumbing.title',
        subtitle: 'services.tabs.plumbing.subtitle',
        text: 'services.tabs.plumbing.text',
        list: [
            'services.tabs.plumbing.li_01',
            'services.tabs.plumbing.li_02',
            'services.tabs.plumbing.li_03',
            'services.tabs.plumbing.li_04',
            'services.tabs.plumbing.li_05',
            'services.tabs.plumbing.li_06',
        ],
    },
    {
        route: 'services/mechanical-works',
        title: 'services.tabs.conditioning.title',
        subtitle: 'services.tabs.conditioning.subtitle',
        text: 'services.tabs.conditioning.text',
        list: [
            'services.tabs.conditioning.li_01',
            'services.tabs.conditioning.li_02',
            'services.tabs.conditioning.li_03',
            'services.tabs.conditioning.li_04',
            'services.tabs.conditioning.li_05',
            'services.tabs.conditioning.li_06',
        ],
    },
    {
        route: 'services/electrical-services',
        title: 'services.tabs.electrical.title',
        subtitle: 'services.tabs.electrical.subtitle',
        text: 'services.tabs.electrical.text',
        list: [
            'services.tabs.electrical.li_01',
            'services.tabs.electrical.li_02',
            'services.tabs.electrical.li_03',
            'services.tabs.electrical.li_04',
            'services.tabs.electrical.li_05',
            'services.tabs.electrical.li_06',
        ],
    },
    {
        route: 'services/mechanical-works',
        title: 'services.tabs.mechanical.title',
        subtitle: 'services.tabs.mechanical.subtitle',
        text: 'services.tabs.mechanical.text',
        list: [
            'services.tabs.mechanical.li_01',
            'services.tabs.mechanical.li_02',
            'services.tabs.mechanical.li_03',
            'services.tabs.mechanical.li_04',
            'services.tabs.mechanical.li_05',
            'services.tabs.mechanical.li_06',
        ],
    },
];

const Tabs = () => {
    const { t } = useTranslation();
    const [active, setActive] = useState(0);
    const [swiper, setSwiper] = useState({});

    return (
        <section className="mt container">
            <div className={classes.wrap}>
                <div className={classes.pagination}>
                    <div className={classes.paginationBody}>
                        <div className={classes.paginationNum}>
                            <span>0{active + 1}</span> / 04
                        </div>
                        <div className={classes.paginationLine}>
                            <div
                                className={classes.paginationLineRed}
                                style={{ width: `${(active + 1) * 25}%` }}
                            ></div>
                        </div>
                    </div>
                    <div className={classes.navigation}>
                        <div
                            className={`${classes.arrow} ${active === 0 && classes.arrowInactive}`}
                            onClick={() => swiper.slidePrev()}
                        >
                            <img src={arrow} alt='' />
                        </div>
                        <div
                            className={`${classes.arrow} ${active === 3 && classes.arrowInactive}`}
                            onClick={() => swiper.slideNext()}
                        >
                            <img src={arrow} alt='' />
                        </div>
                    </div>
                </div>
                <div className={classes.swiperWrap}>
                    <Swiper
                        modules={[Navigation]}
                        className={`${classes.swiper} no-select`}
                        spaceBetween={60}
                        slidesPerView={1}
                        grabCursor
                        onInit={(e) => { setSwiper(e) }}
                        onSlideChange={(e) => setActive(e.activeIndex)}
                    >
                        {cards.map((card, index) =>
                            <SwiperSlide key={index} className={classes.swiperSlide}>
                                <div className={classes.card}>
                                    <div className={classes.content}>
                                        <h2 className={`${classes.title} font-48`}>
                                            <Trans>
                                                {t(card.title)}
                                            </Trans>
                                        </h2>
                                        <h4 className={`${classes.subtitle} font-20`}>
                                            {t(card.subtitle)}
                                        </h4>
                                        <p className={`${classes.text} font-16`}>
                                            {t(card.text)}
                                        </p>
                                        <div className={classes.btn}>
                                            <Button route={card.route}>
                                                {t('btn.see-more')}
                                            </Button>
                                        </div>
                                    </div>
                                    <div className={`${classes.list} font-20`}>
                                        {card.list.map((li, index) =>
                                            <li key={index} className={classes.li}>
                                                <img className={classes.check} src={check} alt='' />
                                                <p>
                                                    {t(li)}
                                                </p>
                                            </li>
                                        )}
                                    </div>
                                </div>
                            </SwiperSlide>
                        )}
                    </Swiper>
                </div>
            </div>
        </section>
    );
};

export default Tabs;
